import { getGenerationResultListId } from 'src/data/generation';
import { createStateSelectorHook } from 'src/lib/sweetState';

import { GenerationStore } from '../store';

const useGenerationState = createStateSelectorHook(GenerationStore, ['lastGenerationResult']);

export const useLastGenerationId = () => {
  const { lastGenerationResult } = useGenerationState();
  return getGenerationResultListId(lastGenerationResult);
};
